import { axiosDS } from '@pp/axios'
import { urls } from 'Constants/Urls'
import { ResponseCatalog, RequestParams } from 'Models'
import { BlockProductGroupModel } from 'Pages/orders/blockProductGroup'
import { SimpleResponse } from 'Types/simpleResponse'

export const blockProductGroupApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<BlockProductGroupModel>>(
			urls.blockProductGroup.index,
			{ params }
		)
		return res.data
	},

	createOne: async (data: BlockProductGroupModel) => {
		const res = await axiosDS().post<BlockProductGroupModel>(urls.blockProductGroup.index, { data })
		return res.data
	},

	updateOne: async (data: BlockProductGroupModel, id: number) => {
		const res = await axiosDS().patch<ResponseCatalog<BlockProductGroupModel>>(
			`${urls.blockProductGroup.index}/${id}`,
			{ data }
		)
		return res.data
	},

	deleteOne: async (id: number) => {
		const res = await axiosDS().delete<SimpleResponse>(`${urls.blockProductGroup.index}/${id}`)
		return res.data
	},
}
